<template>

    <div>

      <v-app-bar app color="secondary darken-1" dark elevation="0">
        <v-btn icon text :to="'/kamus/settings'">
          <v-icon>mdi-database</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title class="title font-weight-bold">KAMUS</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon text @click.native="infoDialog = true">
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
      </v-app-bar>

      <v-container>
      <template v-if="downloadbar">
        <v-row
          class="fill-height"
          align-content="center"
          justify="center"
        >
          <v-col
            class="subtitle-1 text-center"
            cols="12"
          >
            Mengunduh Kamus..
          </v-col>
          <v-col cols="6">
            <v-progress-linear
              color="primary"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </template>

      <template v-else >

        <v-alert type="error" v-if="error">Gagal memuat data...</v-alert>
        <template v-if="!loading">

          <v-toolbar flat dense class="mb-4">
            <v-text-field
              v-model="keyword"
              :placeholder="'Cari sesuatu di Kamus...'"
              full-width
              clearable
              hide-details
              solo
              flat
              color="primary"
              prepend-inner-icon="mdi-magnify"
            />

            <!-- <template v-if="voice.active">
              <v-spacer></v-spacer>
              <v-btn icon @click.native="openSpeechDialog">
                <v-icon>mdi-voice</v-icon>
              </v-btn>
            </template> -->
          </v-toolbar>
          <p v-if="voiceLog">voice log : {{ voiceLog }}</p>
          <!-- <p>hasil voice : {{ voiceText }}</p> -->
          <template  v-if="keyword">
            <p class="text--secondary">hasil pencarian <b>"{{ keyword }}"</b></p>
          </template>

          <v-chip-group
            v-if="!keyword"
            active-class="primary--text"
            v-model="filterAplhabets"
            mandatory
          >
            <v-chip class="mr-4" label v-for="tag in alphabets" :key="tag">
              {{ tag }}
            </v-chip>
          </v-chip-group>

          <template v-if="items.length > 0">
            <v-row dense>
              <v-col cols="12" v-for="item in items" :key="item.id">
                <v-card
                    @click.native="openSheet(item)"
                    outlined
                    min-width="100%"
                >
                  <v-card-title class="subtitle-1">{{item.word}}</v-card-title>
                  <v-card-subtitle>{{item.description}}</v-card-subtitle>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <template v-else >

            <v-card flat tile class="mt-8">
              <v-card-text class="text-center">
                <h4 class="heading">Oops!</h4>
                <p class="text--secondary mb-2">Data tidak ditemukan</p>
              </v-card-text>
            </v-card>

          </template>

        </template>

        <!-- sheet detail -->
        <v-bottom-sheet  v-model="sheetModel">
            <v-card tile flat v-if="selected">
                  <v-card-title class="heading text-center">
                    {{ selected.word }}
                  </v-card-title>
                  <v-divider></v-divider>
                <v-card-text class="mt-4">
                  <p>{{selected.description}}</p>

                </v-card-text>
                <v-card-text class="text-center">
                  <v-btn class="mb-2 mr-2" x-large
                    color="primary" outlined icon @click.native="say(selected)">
                    <v-icon>mdi-volume-high</v-icon>
                  </v-btn>

                </v-card-text>
            </v-card>
        </v-bottom-sheet>

      </template>

      </v-container>

      <v-dialog v-model="infoDialog">
        <v-sheet>

        <v-card flat tile>
              <v-card-text class="text-center pa-8">
                <h4 class="subtitle">Version 1.1</h4>
                <p class="body-2 pa-0 ma-0">Kamus Ekonomi Syariah</p>
              </v-card-text>
        </v-card>

        <v-divider></v-divider>
        <About />
        </v-sheet>
      </v-dialog>

      <v-dialog v-model="voice.dialog">

        <v-card flat tile>

          <v-card-title class="text-center">Kamus Voice Search</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="text-center pa-8">

              <v-btn x-large outlined v-if="voice.state == 0" icon color="green" @click.native="voiceStart">
                <v-icon>mdi-text-to-speech</v-icon>
              </v-btn>
              <v-btn x-large outlined v-if="voice.state == 1" icon color="red" @click.native="voiceStop">
                <v-icon>mdi-text-to-speech-off</v-icon>
              </v-btn>

          </v-card-text>
        </v-card>

      </v-dialog>

    </div>
</template>

<script>
import idb from '@/plugins/indexedDB'
import About from '@/components/About'

export default {
  name: 'Kamus',
  components: {
    About
  },

  data: () => ({
    infoDialog: false,

    alphabets: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    filterAplhabets: 0,
    db: null,
    cats: null,
    ready: false,

    downloadbar: false,

    error: null,
    loading: false,
    keyword: null,
    results: [],

    selected: null,
    sheetModel: false,

    voiceText: '',
    voiceLog: null,
    voice: {
      active: false,
      dialog: false,
      state: 0
    },
    recognition: null

  }),
  async created () {
    this.results = await idb.getKamusAll()
    if (this.results.length == 0) {
      this.downloadbar = true
      let json = await this.downloadData()
      json = this.addIndexAttributes(json)

      await idb.saveKamusAll(json)
      this.results = await idb.getKamusAll()
      this.downloadbar = false
    }

    this.voice.active = this.initSpeech()
  },
  methods: {

    openSpeechDialog: function () {
      this.voice.dialog = true
    },
    voiceStart () {
      this.recognition.start()
      this.voice.state = 1
    },
    voiceStop () {
      this.recognition.stop()
      this.voiceLog = (this.recognition.onresult)
      this.keyword = 'Ahli Waris'

      // this.recognition.addEventListener("result", function(event){
      //   for (const res of event.results) {
      //     this.voiceText = document.createTextNode(res[0].transcript);
      //     if (res.isFinal) {
      //       alert("selesai")
      //     }
      //   }
      // });
      this.voice.state = 0
      this.voice.dialog = false
    },
    initSpeech: function () {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
      if (typeof SpeechRecognition === 'undefined') {
        return false
      } else {
        let listening = false
        this.recognition = new SpeechRecognition()
        this.recognition.continuous = true
        this.recognition.interimResults = true
        this.recognition.lang = 'id'
        return true
      }
    },

    addIndexAttributes: function (json) {
      json.forEach((each, i) => {
        json[i].indexWord = json[i].word.trim().charAt(0)
      })

      return json
    },

    say: async function (item) {
      const word = item.word + ' adalah ' + item.description

      const utterThis = new SpeechSynthesisUtterance(word)
      utterThis.lang = 'id'

      speechSynthesis.speak(utterThis)
    },
    async downloadData () {
      var url = 'dictionary'
      return await this.$axios
        .get(url)
        .then(response => {
          return response.data.results
        })
        .catch(error => {
          this.error = true
          this.downloadbar = false
        })
    },

    openSheet: function (item) {
      this.selected = item
      this.sheetModel = true
    }

  },
  computed: {

    items () {
      if (this.keyword) {
        const keyword = this.keyword.toLowerCase()
        return this.results.filter(result => result.word.toLowerCase().includes(keyword) || result.description.toLowerCase().includes(keyword))
      }

      if (this.filterAplhabets) {
        return this.results.filter(result => result.indexWord === this.alphabets[this.filterAplhabets])
      }

      return this.results.filter(result => result.indexWord === this.alphabets[0])
    }

  }
}
</script>
